// 院校相关接口
const institution = {
    province: '/institution/province/list',                      // 获取省份列表
    institution_info: '/institution/list',    // 获取院校列表
    institution_by_province: '/institution/province', // 根据省份获取院校列表
}
export default institution; 